export default __webpack_public_path__ + "static/media/bg2.cc4d28a5.jpg";